import type { TFunction } from "i18next";
import { formatExplorerLimitResetUtc } from "./formatExplorerLimitResetUtc";
import { getExplorerMessagingLimitErrorBody } from "./explorerMessagingError";

export function getExplorerMessagingLimitReachedMessage(
  t: TFunction,
  locale: string,
  options: {
    weekResetsUtc?: string;
    used?: number;
    limit?: number;
  }
): string {
  const { weekResetsUtc, used = 5, limit = 5 } = options;
  const when = formatExplorerLimitResetUtc(weekResetsUtc, locale);
  const resetLabel = when
    ? t("messages.explorerWeeklyResetAt", { when })
    : t("messages.explorerWeeklyResetFallback");
  return t("messages.explorerWeeklyLimitReached", { used, limit, resetLabel });
}

export function getExplorerMessagingLimitCounterMessage(
  t: TFunction,
  locale: string,
  options: {
    weekResetsUtc?: string;
    used?: number;
    limit?: number;
  }
): string {
  const { weekResetsUtc, used = 0, limit = 5 } = options;
  return t("messages.explorerWeeklyCounter", {
    used,
    limit,
    remaining: Math.max(0, limit - used),
    resetLabel: getExplorerMessagingWeeklyResetLabel(t, locale, weekResetsUtc),
  });
}

export function getExplorerMessagingWeeklyResetLabel(
  t: TFunction,
  locale: string,
  weekResetsUtc?: string
): string {
  const when = formatExplorerLimitResetUtc(weekResetsUtc, locale);
  if (!when) {
    return t("messages.explorerWeeklyResetFallback");
  }
  return t("messages.explorerWeeklyResetAt", { when });
}

export function getExplorerMessagingLimitMessageFromError(
  t: TFunction,
  error: unknown,
  locale: string,
  fallback?: { weekResetsUtc?: string; used?: number; limit?: number }
): string {
  const data = getExplorerMessagingLimitErrorBody(error);
  return getExplorerMessagingLimitReachedMessage(t, locale, {
    weekResetsUtc: data?.weekResetsUtc ?? fallback?.weekResetsUtc,
    used: data?.used ?? fallback?.used,
    limit: data?.limit ?? fallback?.limit,
  });
}
